import { Box } from "@mui/material";
import classes from "./index.module.scss";

export default function Section({ children }) {
  return <Box className={classes.section}>{children}</Box>;
}
